// Dépendances Angular
import { inject, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';

// Dépendances Externes
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';

// Fichiers du projet
import { AuthenticationComponent, AssistanceComponent, CallbackComponent } from '@features/index';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { configSSO } from '@environments/sso/auth-sso';
import { SharedModule } from '@shared/shared.module';
import { HttpTokenInterceptor } from '@core/interceptors/http.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    AuthenticationComponent,
    AssistanceComponent,
    CallbackComponent,
  ],
  imports: [
    // Dépendances Angular
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,

    // Dépendances externes
    SharedModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    provideHttpClient(withInterceptors([HttpTokenInterceptor])),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  private oAuthService: OAuthService = inject(OAuthService);

  constructor() {
    this.oAuthService.configure(configSSO);
    this.oAuthService.setupAutomaticSilentRefresh({}, 'access_token');
    this.oAuthService.loadDiscoveryDocumentAndTryLogin();
  }
}
